import React from "react";
import { Helmet } from "react-helmet";
import Nav from "./nav";
import Footer from "./footer";
import StickyMobileFooter from "./stickymobilefooter";

export default function Layout({ children }) {
  return (
    <div className="">
      <Helmet>
        <script>
          {`
              (function(w,d,e,u,f,l,n){w[f]=w[f]||function(){(w[f].q=w[f].q||[])
                                            .push(arguments);},l=d.createElement(e),l.async=1,l.src=u,  n=d.getElementsByTagName(e)[0],n.parentNode.insertBefore(l,n);})                                 (window,document,'script','https://assets.mailerlite.com/js/universal.js','ml');
               ml('account', '1545109');
             `}
        </script>
      </Helmet>
      <Nav />
      <main className="pt-[90px]">{children}</main> {/* bg-[#457B9D]  */}
      <Footer />
      <StickyMobileFooter />
    </div>
  );
}
